module.exports = __webpack_public_path__ + "static/img/brees-2015-slide-7.2c0a6f6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brees-2015-slide-7.jpg
// module id = /5a7
// module chunks = 1